exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#hero-select-view {\n  width: 100%; }\n  #hero-select-view .hero-list {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    margin-bottom: -50px; }\n  #hero-select-view .hero-option {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 0 25px 25px; }\n  #hero-select-view .hero-avatar {\n    margin: 6px;\n    background-color: #f8f8f8;\n    box-shadow: 0 0 0 1px gray; }\n  #hero-select-view .current .hero-avatar {\n    box-shadow: 0 0 0 6px gray; }\n  #hero-select-view .selected .hero-avatar {\n    box-shadow: 0 0 0 6px #F2BE19; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/import-glob-loader!./app/styles/core/hero-select-view.sass
// module id = 842
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91